export class ListStampRubric {
  stamps: Array<any>;
  rubrics: Array<any>;
  customFields: Array<any>;

  constructor(stamps: Array<any>, rubrics: Array<any>, customFields: Array<any> = []) {
    this.stamps = stamps;
    this.rubrics = rubrics;
    this.customFields = customFields;
  }
}
